import {combineReducers} from 'redux';

import listsOverviewReducer, {type ListsOverviewState} from './lists-overview/reducer';
import newListReducer, {type NewListState} from './new-list/reducer';

export interface ListsState {
    overview: ListsOverviewState;
    newList: NewListState;
}
export default combineReducers<ListsState>({newList: newListReducer, overview: listsOverviewReducer});
